import React from 'react';
import { Pagination, Stack } from '@mui/material';
import './pagination.css';

export const TablePagination = ({ totalPages, page, handlePageChange }) => {
  return (
    <Stack spacing={2}>
      <Pagination
        count={Math.ceil(totalPages / 10)}
        page={page}
        onChange={(event, value) => handlePageChange(value)}
        variant="outlined"  
        shape="rounded"  
        siblingCount={1} 
        boundaryCount={1}  
        />
    </Stack>
  );
};
